import { CircularProgress, CircularProgressProps } from "@mui/material";

const Spinner = (props: CircularProgressProps) => {
  return <CircularProgress {...props} />;
};

export default Spinner;
